var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("card", { staticClass: "stacked-form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmit($event)
                }
              }
            },
            [
              _c(
                "fg-input",
                {
                  attrs: {
                    required: true,
                    label: "KAtegori Pelanggan",
                    "for-input": "customerCategory",
                    error: _vm.errors.first("customerCategory")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.modelValidations.customerCategory,
                          expression: "modelValidations.customerCategory"
                        }
                      ],
                      attrs: {
                        size: "large",
                        id: "customerCategory",
                        name: "customerCategory",
                        "data-vv-as": "customerCategory",
                        placeholder: "Pilih customerCategory"
                      },
                      model: {
                        value: _vm.model.customerCategory,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "customerCategory", $$v)
                        },
                        expression: "model.customerCategory"
                      }
                    },
                    _vm._l(_vm.customerCategoryList, function(option) {
                      return _c("el-option", {
                        key: option.id,
                        attrs: { value: option.id, label: option.name }
                      })
                    })
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("fg-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.modelValidations.name,
                    expression: "modelValidations.name"
                  }
                ],
                attrs: {
                  required: true,
                  "for-input": "name",
                  type: "text",
                  name: "name",
                  id: "name",
                  label: "Nama",
                  placeholder: "Masukkan nama",
                  error: _vm.errors.first("name"),
                  "data-vv-as": "Name"
                },
                model: {
                  value: _vm.model.name,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "name", $$v)
                  },
                  expression: "model.name"
                }
              }),
              _vm._v(" "),
              _c("fg-input", {
                attrs: {
                  required: true,
                  "for-input": "address",
                  type: "text",
                  name: "address",
                  id: "address",
                  label: "Alamat",
                  placeholder: "Enter address"
                },
                model: {
                  value: _vm.model.address,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "address", $$v)
                  },
                  expression: "model.address"
                }
              }),
              _vm._v(" "),
              _c("fg-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.modelValidations.email,
                    expression: "modelValidations.email"
                  }
                ],
                attrs: {
                  required: true,
                  "for-input": "email",
                  type: "text",
                  name: "email",
                  id: "email",
                  label: "Email",
                  placeholder: "Masukkan email",
                  error: _vm.errors.first("email"),
                  "data-vv-as": "Email"
                },
                model: {
                  value: _vm.model.email,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "email", $$v)
                  },
                  expression: "model.email"
                }
              }),
              _vm._v(" "),
              _c("fg-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.modelValidations.phone,
                    expression: "modelValidations.phone"
                  }
                ],
                attrs: {
                  required: true,
                  "for-input": "phone",
                  type: "text",
                  name: "phone",
                  id: "phone",
                  label: "Telelpon",
                  placeholder: "Masukkan nomor telepon",
                  error: _vm.errors.first("phone"),
                  "data-vv-as": "Phone"
                },
                model: {
                  value: _vm.model.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "phone", $$v)
                  },
                  expression: "model.phone"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: { "has-error": _vm.errors.first("registeredDate") }
                },
                [
                  _c("label", [_vm._v("Terdaftar tanggal *")]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    attrs: { placeholder: "Date Of Birth" },
                    model: {
                      value: _vm.fakeModel.registeredDate,
                      callback: function($$v) {
                        _vm.$set(_vm.fakeModel, "registeredDate", $$v)
                      },
                      expression: "fakeModel.registeredDate"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.model.registeredDate,
                        expression: "model.registeredDate"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.modelValidations.registeredDate,
                        expression: "modelValidations.registeredDate"
                      }
                    ],
                    attrs: {
                      type: "hidden",
                      name: "registeredDate",
                      "data-vv-as": "date of birth"
                    },
                    domProps: { value: _vm.model.registeredDate },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.model,
                          "registeredDate",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._t("infoBlock"),
                  _vm._v(" "),
                  _vm._t("helpBlock", [
                    _vm.errors.first("registeredDate")
                      ? _c(
                          "div",
                          {
                            staticClass: "text-danger invalid-feedback",
                            staticStyle: { display: "block" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("registeredDate")) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("cancel-button"),
              _vm._v(" "),
              _c("save-data-button", {
                attrs: {
                  disabled: _vm.saveButtonData.isLoading,
                  "is-create": _vm.$route.params.id === undefined,
                  state:
                    _vm.saveButtonData.isLoading &&
                    _vm.saveButtonData.state === 1
                      ? 2
                      : _vm.saveButtonData.state,
                  "is-loading": _vm.saveButtonData.isLoading
                }
              })
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d249b30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d249b30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Customers/Form.vue
// module id = Ry6K
// module chunks = 4